(function($){
$(function() {
	if( ! jQuery.browser.mobile ){
		$('.product-thumbnail-image').on('mouseover', function() {
			var $this = $(this),
				image2 = $this.find('.image2');

			if( image2.length > 0 ){
				$this.find('.image1').hide();
				image2.show();
			}
		});

		$('.product-thumbnail-image').on('mouseout', function() {
			var $this = $(this),
				image2 = $this.find('.image2');

			if( image2.length > 0 ){
				$this.find('.image1').show();
				image2.hide();
			}
		});
	}
});
})(jQuery);